import fading_entrances from './animations/fading_entrances';
import fading_exits from './animations/fading_exits';
import sliding_entrances from './animations/sliding_entrances';

export default {
  ...fading_entrances,
  ...fading_exits,
  ...sliding_entrances,
};
